import IconFont from "./IconFont.vue";
export default {
  install: function (Vue) {
    Vue.component("IconFont", IconFont);
  },
};
